export class ProjectAcceptanceDTO
{
    Id: string;
    Acceptance: string;
    Lock: boolean;
}